import React from "react";
import { useSelector } from "react-redux";
import { Discovery } from "components/Discovery";
import __ from "utils/i18n";

export const MassivePaymentLinkDiscovery = () => {
  const { paymentLink: showPaymentDiscovery = false } = useSelector(
    (state) => state.dashboard.discovery
  );
  const steps = [
    {
      title: __("discovery.massivePaymentLink.title"),
      content: __("discovery.massivePaymentLink.message"),
      showCloseButton: false,
      disableBeacon: true,
      placement: "bottom",
      target: ".massive-payment-link",
    },
  ];
  // TODO eliminar showDiscovery y su implementación
  const showDiscovery = localStorage.getItem('showDiscovery')
  return (
    <>
    {showDiscovery &&
      <Discovery run={showPaymentDiscovery} steps={steps} discoveryId="massivePaymentLink" />
    }
    </>
  );
};
